import React from "react";
import {useTranslation} from "react-i18next";

const TabSwitch = ({ items = [], activeTab, onChange }) => {
  const { t } = useTranslation();
  return (
    <div className="font-medium text-center text-gray-500">
      <ul className="flex">
        {items.map((item) => (
          <li
            key={item}
            className={`inline-block p-2 cursor-pointer text-xs rounded-t-lg border-t border-l border-r border-gray-300 ${
              activeTab === item
                ? "text-gray-600 rounded-t-lg border-t border-l border-r border-gray-400 bg-white"
                : "hover:bg-gray-200"
            }`}
            onClick={() => onChange(item)}
          >
            {t(item)}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default TabSwitch;
